import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '../Button/Button'
import { DateInput } from '../DateInput/DateInput'
import { polyglot } from '../../../index'

class RadioButtons extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      labelSize: props.expandInputArea ? 3 : 6,
      selectedOption: 'hidden'
    }
    this.handleOptionChange = this.handleOptionChange.bind(this)
    this.handleInnerFieldChange = this.handleInnerFieldChange.bind(this)
  }

  componentWillMount () {
    if (this.props.savedData) {
      let value
      this.props.inputs.map(function (element) {
        if (element.value === this.props.savedData) {
          value = element.value
        }
      }.bind(this))
      if (value) {
        this.setState({
          selectedOption: this.props.savedData,
          selectedValue: value
        })
      } else {
        this.setState({
          selectedOption: 'positive',
          selectedValue: this.props.savedData
        })
      }
    }
  }

  handleOptionChange (changeEvent) {
    this.setState({
      selectedValue: undefined,
      selectedOption: changeEvent.target.value
    }, () => {
      if (this.props.onSelectChange) {
        this.props.onSelectChange(this.state.selectedOption)
      }
      if (this.state.selectedOption === 'negative') {
        this.props.getFieldValue(this.props.name, this.state.selectedOption)
      } else {
        if (!this.props.innerField) {
          this.props.getFieldValue(this.props.name, this.state.selectedOption)
        } else {
          this.props.getFieldValue(this.props.name, this.state.selectedOption)
        }
      }
    })
  }

  handleInnerFieldChange (name, value) {
    let _value = value
    if (value === '') {
      _value = 'positive'
    }
    this.setState({
      [name]: _value
    }, () => {
      this.props.getFieldValue(this.props.name, this.state[this.props.innerField.name])
    })
  }

  render () {
    return <div className='form-group checkbox-with-text'>
      <label className={`col-xs-${this.state.labelSize} control-label`}>{polyglot.t(this.props.label)}</label>
      <div className={`col-xs-${12 - this.state.labelSize}`}>
        {this.props.inputs.map(element => {
          return (
            <label key={element.displayValue} className='radio-inline input-radio'>
              <input type='radio'
                required={this.props.required}
                id='inlineCheckbox1'
                value={element.value}
                onChange={this.handleOptionChange}
                checked={this.state.selectedOption === element.value}
                name={this.props.name} /> {polyglot.t(element.displayValue)} </label>
          )
        })}
        {this.props.innerField
          ? this.state.selectedOption === 'positive'
            ? <InnerInput
              savedData={this.state.selectedValue !== 'positive' ? this.state.selectedValue : ''}
              fieldType={this.props.innerField.fieldType}
              placeholder={this.props.innerField.placeholder}
              options={this.props.innerField.options}
              type={this.props.innerField.type}
              key={`${this.props.innerField.name}_1`}
              name={this.props.innerField.name}
              required={this.props.innerField.required}
              onChange={this.handleInnerFieldChange} />
            : null
          : null
        }
      </div>
    </div>
  }
}

RadioButtons.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  getFieldValue: PropTypes.func.isRequired,
  inputs: PropTypes.arrayOf(PropTypes.shape({displayValue: PropTypes.string.isRequired, value: PropTypes.string.isRequired})).isRequired,
  innerField: PropTypes.object,
  onSelectChange: PropTypes.func,
  required: PropTypes.bool,
  expandInputArea: PropTypes.bool,
  savedData: PropTypes.any
}

RadioButtons.defaultProps = {
  required: false
}

class InnerInput extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      mainInputVisible: false,
      value: props.savedData,
      other: props.savedData
    }
    this.handleChange = this.handleChange.bind(this)
    this.multipleInputHandle = this.multipleInputHandle.bind(this)
  }
  componentWillMount () {
    if (this.props.savedData && this.props.options) {
      this.props.options.forEach(element => {
        if (element.value === this.props.savedData) {
          this.setState({
            mainInputVisible: true
          })
        }
      })
    } else {
      this.setState({
        mainInputVisible: true
      })
    }
  }
  handleOtherFieldChange (e) {
    if (e.target.value === '') {
      this.refs.select.value = ''
      this.setState({
        mainInputVisible: true
      })
    }
    this.setState({
      other: e.target.value
    }, this.props.onChange(this.props.name, e.target.value))
  }
  handleChange (e) {
    if (e.target.value === 'other') {
      this.setState({
        other: '',
        mainInputVisible: false
      })
    } else {
      this.setState({
        value: e.target.value
      }, this.props.onChange(e.target.name, e.target.value))
    }
  }

  multipleInputHandle (name, values) {
    this.props.onChange(name, values)
  }

  render () {
    if (this.props.type === 'text') {
      return <div className='col-xs-6' style={{float: 'right'}}>
        <input
          value={this.state.value}
          required={this.props.required}
          onChange={e => this.handleChange(e)}
          name={this.props.name}
          placeholder={polyglot.t(this.props.placeholder)}
          type={this.props.fieldType}
          className='form-control'
          style={{float: 'right'}} />
      </div>
    } else if (this.props.type === 'select') {
      return <div className='col-xs-6' style={{float: 'right'}}>
        <div hidden={!this.state.mainInputVisible}>
          <select ref={'select'} defaultValue={this.props.savedData} required className='form-control' name={this.props.name} id='select' onChange={e => this.handleChange(e)}>
            <option disabled hidden value={''} />
            {
              this.props.options.map(function (element) {
                return (<option key={element.value} value={element.value} label={polyglot.t(element.label)} />)
              })
            }
          </select>
        </div>
        <input type='text' value={this.state.other} required={!this.state.mainInputVisible} onChange={e => this.handleOtherFieldChange(e)} placeholder={polyglot.t('staticFields.commonFields.insertValue')} className={`form-control ${this.state.mainInputVisible ? 'hidden' : null}`} />
      </div>
    } else if (this.props.type === 'multipleText') {
      return <div className='col-xs-6' style={{float: 'right'}}>
        <MultipleInnerInput savedData={this.props.savedData} handleChange={this.multipleInputHandle} name={this.props.name} placeholder={this.props.placeholder} fieldType={this.props.fieldType} />
      </div>
    } else if (this.props.type === 'multipleSelect') {
      return <div className='col-xs-6' style={{float: 'right'}}>
        <MultipleInnerSelect options={this.props.options} savedData={this.props.savedData} handleChange={this.multipleInputHandle} name={this.props.name} placeholder={this.props.placeholder} />
      </div>
    }
  }
}

InnerInput.propTypes = {
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  fieldType: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array,
  name: PropTypes.string.isRequired,
  savedData: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired
}

InnerInput.defaultProps = {
  savedData: ''
}

class MultipleInnerInput extends React.Component {
  constructor (props) {
    super(props)
    let value = props.savedData
    if (value === '') {
      value = []
    }
    this.state = {
      value: value,
      count: props.savedData.length || 1
    }
    this.handleDateInputChange = this.handleDateInputChange.bind(this)
  }

  handleChange (i, event) {
    let value = this.state.value.slice()
    value[i] = event.target.value
    if (value[i] === '') {
      value[i] = null
      if (this.state.count > 1) {
        this.setState({
          count: this.state.count - 1
        })
      }
    }
    this.setState({
      value
    }, this.props.handleChange(this.props.name, value))
  }

  handleDateInputChange (name, val) {
    let value = this.state.value.slice()
    value[name] = val
    if (value[name] === '') {
      value[name] = null
      if (this.state.count > 1) {
        this.setState({
          count: this.state.count - 1
        })
      }
    }
    this.setState({
      value
    }, this.props.handleChange(this.props.name, value))
  }

  addClick () {
    this.setState({count: this.state.count + 1})
  }

  createUI () {
    let uiItems = []
    for (let i = 0; i < this.state.count; i++) {
      uiItems.push(
        <div key={i}>
          {this.props.fieldType === 'date'
            ? <DateInput
              handleChange={this.handleDateInputChange}
              name={`${i}`} value={this.state.value[i] || undefined}
              placeholder={polyglot.t(this.props.placeholder)}
              required={this.state.count === 1} />
            : <input
              required={this.state.count === 1}
              value={this.state.value[i] || ''}
              onChange={this.handleChange.bind(this, i)}
              placeholder={polyglot.t(this.props.placeholder)}
              type={this.props.fieldType}
              className='form-control'
              style={{float: 'right'}} />
          }
        </div>
      )
    }
    return uiItems || null
  }

  render () {
    return <div style={{float: 'right'}} ref='innerContainer'>
      {this.createUI()}
      <div className='col-xs-12 no-padding' style={{float: 'right', marginTop: '2px'}}>
        <Button
          onClick={this.addClick.bind(this)}
          text={'+'}
          buttonType='btn btn-primary btn-block'
          type={'button'} />
      </div>
    </div>
  }
}

MultipleInnerInput.propTypes = {
  handleChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  fieldType: PropTypes.string.isRequired,
  savedData: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
}

class MultipleInnerSelect extends React.Component {
  constructor (props) {
    super(props)
    let value = props.savedData
    if (value === '') {
      value = []
    }
    this.state = {
      value: value,
      mainInputVisible: undefined,
      count: props.savedData.length || 1
    }
  }

  componentWillMount () {
    let mainInputVisible = {}
    for (let i = 0; i < this.state.count; i++) {
      mainInputVisible[i] = true
    }
    this.setState({
      mainInputVisible: mainInputVisible
    })
  }

  handleChange (i, event) {
    if (event.target.value === 'other') {
      this.setState({
        other: ''
      })
    } else {
      let value = this.state.value.slice()
      value[i] = event.target.value
      if (value[i] === '') {
        value[i] = null
        if (this.state.count > 1) {
          this.setState({
            count: this.state.count - 1
          })
        }
      }
      this.setState({
        value
      }, this.props.handleChange(this.props.name, value))
    }
  }
  addClick () {
    const mainInputVisible = this.state.mainInputVisible
    mainInputVisible[this.state.count] = true
    this.setState({count: this.state.count + 1, mainInputVisible: mainInputVisible})
  }

  createUI () {
    let uiItems = []
    for (let i = 0; i < this.state.count; i++) {
      uiItems.push(
        <div key={i}>
          <div hidden={!this.state.mainInputVisible[i]}>
            <select ref={'select'} defaultValue={this.props.savedData[i]} required className='form-control' name={this.props.name} id='select' onChange={e => this.handleChange(i, e)}>
              <option disabled hidden value={''} />
              {
                this.props.options.map(function (element) {
                  return (<option key={element.value} value={element.value} label={polyglot.t(element.label)} />)
                })
              }
            </select>
          </div>
          <input type='text' value={this.state.other} required={!this.state.mainInputVisible[i]} onChange={e => this.handleOtherFieldChange(e)} placeholder={polyglot.t('staticFields.commonFields.insertValue')} className={`form-control ${this.state.mainInputVisible[i] ? 'hidden' : null}`} />
        </div>
      )
    }
    return uiItems || null
  }

  render () {
    return <div style={{float: 'right'}} ref='innerContainer'>
      <div>
        {this.createUI()}
      </div>
      <div className='col-xs-12 no-padding' style={{float: 'right', marginTop: '2px'}}>
        <Button
          onClick={this.addClick.bind(this)}
          text={'+'}
          buttonType='btn btn-primary btn-block'
          type={'button'} />
      </div>
    </div>
  }
}

MultipleInnerSelect.propTypes = {
  handleChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  savedData: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
}

export {RadioButtons}



// WEBPACK FOOTER //
// ./src/components/common/RadioButtons/RadioButtons.js